import { Apollo } from 'apollo-angular';
import { DialogService } from '@ngneat/dialog';
import { AuthContext } from '@iss/libs/auth';
import { inject, Injectable } from '@angular/core';

import { ImpersonateDialogComponent } from './dialog';

import { LocalStorageService } from '@iss/wo-common/local-storage';

export type ImpersonateContext = Readonly<{
  withImpersonation: boolean;
  label: string;
}>;

@Injectable()
export class ImpersonateService {
  private readonly localStorage = inject(LocalStorageService);
  private readonly dialog = inject(DialogService);
  private readonly apollo = inject(Apollo);

  public getImpersonateId(): string | null {
    return AuthContext.getImpersonatedEmail();
  }

  public async setImpersonateId(impersonateId: string): Promise<void> {
    AuthContext.setImpersonatedEmail(impersonateId);
    await this.onImpersonationChanged();
  }

  private async quitImpersonation(): Promise<void> {
    AuthContext.clearImpersonatedEmail();
    await this.onImpersonationChanged();
  }

  private async onImpersonationChanged(): Promise<void> {
    this.localStorage.clearVolatileValues();
    await this.apollo.client.clearStore();
    window.location.href = '/';
  }

  public async onImpersonation(): Promise<void> {
    if (this.getImpersonateId() == null) {
      ImpersonateDialogComponent.open(this.dialog);
    } else {
      await this.quitImpersonation();
    }
  }
}
